



















import { defineComponent, computed } from '@nuxtjs/composition-api'
import { useProductSelections } from '~/composables/product/useProductSelection'
import { useAuth } from '~/composables/useAuth'
import BaseIcon from "~/components/base/Icon.vue";

export default defineComponent({
  name: 'CartFavorite',
  components: {BaseIcon},
  props: {
    productId: {
      type: Number,
      default: undefined,
    },
  },

  setup(props) {
    const { authed, ensureAuthed } = useAuth()
    const {
      getAllSectionsLoading,
      addProductSelectionLoading,
      removeProductSelectionLoading,

      getProductSelection,
      getAllSelections,
      addProductSelection,
      removeProductSelection,
    } = useProductSelections()

    if (authed.value && process.client) {
      getAllSelections()
    }

    const loading = computed(
      () =>
        getAllSectionsLoading.value ||
        addProductSelectionLoading.value ||
        removeProductSelectionLoading.value
    )

    const productSelection = computed(() => {
      if (props.productId === undefined) return null
      return getProductSelection(props.productId)
    })

    const isFavorite = computed(() => {
      if (props.productId === undefined) return false
      return !!productSelection.value
    })

    
    const iconDefault = computed(() => {
      return isFavorite.value ? 'gw-heart-solid' : 'gw-heart-linear'
    })

    const iconValue = isFavorite.value ? 'gw-heart-solid' : 'gw-heart-linear'

    const onClick = () => {
      ensureAuthed(() => {
        if (props.productId === undefined) return
        if (!isFavorite.value) {
          addProductSelection(props.productId)
        } else if (productSelection.value?.id) {
          removeProductSelection(productSelection.value.id)
        }
      })
    }

    return {
      isFavorite,
      loading,
      iconDefault,
      iconValue,

      onClick
      
    }
  },
})
